import { multiSelectorOptionsMapper, optionsMapper } from '../utils';

const options = [
  { label: 'Prioridade 1', value: 1 },
  { label: 'Prioridade 2', value: 2 },
  { label: 'Prioridade 3', value: 3 },
];

export const usePrioritizedProductPriorityOptions = () => {
  return {
    singleSelectOptions: options.map(optionsMapper),
    multiSelectOptions: options.map(multiSelectorOptionsMapper),
  }
}